import React from 'react';
import { matchPath, Navigate, useLocation } from 'react-router-dom';

import useSelector from 'hooks/useSelector';
import { jwtDecodedSelector } from 'store/user/selectors';
import { UserRoleEnum } from 'common/user/enums/user-role.enum';
import { isValidTokenByRoleHelper } from './helpers/is-valid-token-by-role.helper';
import { LogoutPage } from 'routes/paths';
import { useManager } from '../contexts/access/ManagerContext/useManager';
import { paths } from '../App';

type InputProps = {
  children: JSX.Element;
};

export const ManagerGuard = ({ children }: InputProps) => {
  const location = useLocation();
  const accessToken = useSelector(jwtDecodedSelector);
  const { grantManager } = useManager();

  grantManager(accessToken?.isReadOnly || false);

  if (
    accessToken?.isReadOnly &&
    !!matchPath(paths.DashboardPage, location.pathname)
  )
    return (
      <Navigate
        to={paths.DashboardDriversPage}
        replace
        state={{ path: location.pathname }}
      />
    );

  return isValidTokenByRoleHelper(UserRoleEnum.MANAGER, accessToken) ? (
    children
  ) : (
    <Navigate to={LogoutPage} replace state={{ path: location.pathname }} />
  );
};
